/**
 * Gate 1 — Step 5: Test Cases REST client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = (projectId) => `${API_BASE_URL}/projects/${projectId}/gate1/test-cases`;

export async function fetchTestCases(projectId) {
  const res = await axios.get(base(projectId));
  return res.data;
}

export async function generateTestCases(projectId) {
  const res = await axios.post(`${base(projectId)}/generate`);
  return res.data;
}

export async function addTestCase(projectId, testCase) {
  const res = await axios.post(`${base(projectId)}/cases`, testCase);
  return res.data;
}

export async function updateTestCase(projectId, testCaseId, patch) {
  const res = await axios.put(`${base(projectId)}/cases/${testCaseId}`, patch);
  return res.data;
}

export async function fetchTestCaseHistory(projectId, testCaseId) {
  const res = await axios.get(`${base(projectId)}/cases/${testCaseId}/history`);
  return res.data;
}

export async function deleteTestCase(projectId, testCaseId) {
  const res = await axios.delete(`${base(projectId)}/cases/${testCaseId}`);
  return res.data;
}
